import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { QUERIES } from '@/constants/queries'
import { REQUEST_STATUS } from '@/constants/request-status'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import { getStudentRequestById } from '@/services/requests/get-student-requests-by-id'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'

export const useStudentMyReviews = () => {
  const { id } = useParams()

  const { data: request, isLoading } = useQuery({
    queryKey: [QUERIES.QUERY_GET_REQUEST_BY_ID, id],
    queryFn: () => getStudentRequestById(id!)
  })

  const { control, reset } = useForm<MatchCoursesFormType>({})

  const { fields, append } = useFieldArray({
    control,
    name: 'courseEquivalences'
  })

  const formMethods: StudentRequestedCoursesFormMethods = {
    fields,
    control
  }

  const grantStatus = request?.requestStatus.id === REQUEST_STATUS.GRANT.id
  const showEquivalencesTable =
    request?.requestStatus.id !== REQUEST_STATUS.DENY.id

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (request) {
      reset()
      request?.courseEquivalences.forEach((equivalence) => {
        append(equivalence as any)
      })
    }
  }, [request])

  return {
    states: {
      request,
      isLoading,
      formMethods,
      grantStatus,
      showEquivalencesTable
    }
  }
}
